import { combineReducers } from "redux";
import AutoCompleteReducer from "./getAutoCompleteReducer";
import SearchConfigReducer from "./getConfigReducer";
import getDownloadPOIReportReducer from "./getDownloadPOIReportReducer";
import NewPoiReducer from "./getNewPoisReducer";
import POICudReducer from "./getPOICudReducer";
import POIViewDataReducer from "./getPOIViewDataReducer";
import FullSearchReducer from "./getSearchReducer";
import CoordsReducer from "./getCoordsReducer";
import RollListReducer from "./getRollListReducer";
import CityReducer from "./getCityReducer";

const NBHDReducer = combineReducers({
    DownloadPOIReport: getDownloadPOIReportReducer,
    POIViewData: POIViewDataReducer,
    POICud: POICudReducer,
    Config: SearchConfigReducer,
    AutoComplete: AutoCompleteReducer,
    Search: FullSearchReducer,
    NewPoi: NewPoiReducer,
    Coords: CoordsReducer,
    RollList: RollListReducer,
    CityCoords: CityReducer,
});

export default NBHDReducer;
